<template>
  <div class="group">
    <Button v-for="(button, index) in buttons" :key="index" :label="button.label"
      :class="{ active: index === activeButton }" @click="handleButtonClick(index)" />
  </div>
</template>

<style scoped lang="scss">
.group {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;

  .btn {
    flex-grow: 1;
    border-radius: 0;
    border-top: 1px solid #FFF;
    border-bottom: 1px solid #FFF;
    border-left: 1px solid #FFF;

    background-color: transparent;
    font-size: 15px;
    font-weight: 400;

    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-right: 1px solid #FFF;
    }

    &.active {
      color: #1D1D1D;
      background-color: #F2CB36;
      font-weight: 600;
    }
  }
}
</style>

<script setup lang="ts">
import { ref } from "vue";

interface Button {
  label: string;
}

const props = defineProps<
  {
    buttons: Button[];
    defaultIndex?: number;
  }>();

const emit = defineEmits<{
  click: [index: number]
}>();

const activeButton = ref(props.defaultIndex ?? 0);

function handleButtonClick(index: number) {
  activeButton.value = index;
  emit('click', index);
}
</script>